import { lazy, Suspense } from "react";
import { LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSession } from "@/context/SessionContext";

const AccountMenu = lazy(() => import("./AccountMenu").then((module) => ({ default: module.AccountMenu })));

export const AccountControl = () => {
  const { user, loading, signIn } = useAuth();
  const { endSession } = useSession();

  if (user) return (
    <Suspense fallback={<span className="text-xs text-mist" data-testid="account-loading">Account…</span>}>
      <AccountMenu />
    </Suspense>
  );

  return (
    <button
      disabled={loading}
      onClick={() => { endSession(); signIn(); }}
      data-testid="nav-sign-in-button"
      aria-label="Sign in or sign up with Google"
      className="inline-flex items-center gap-2 rounded-full bg-neon text-ink font-semibold whitespace-nowrap text-xs sm:text-sm px-3 sm:px-5 py-2.5 transition-colors hover:bg-neonhover disabled:opacity-50"
    >
      <LogIn size={15} className="hidden sm:block" />
      {loading ? "Checking…" : <><span>Sign in</span><span className="hidden sm:inline">/ Sign up</span></>}
    </button>
  );
};